// Material UI
import { makeStyles } from '@material-ui/core';
// Consts
import Colors from '../../constants/Colors';
import { neutral } from '../../shared/styles/colors';

export default makeStyles(theme => {
  return {
    customAlertPaymentMethodRoot: {
      fontSize: 11,
      fontStyle: 'normal !important',
      lineHeight: 'normal !important',
      letterSpacing: 0,
      padding: '10px !important',
      width: '100%',
    },
    description: {
      whiteSpace: 'pre-line',
      fontSize: 11,
    },
    root: {
      color: neutral.D20,
      display: 'grid',
      gridRowGap: 12,
      fontSize: 12,
      lineHeight: 'normal',
    },
    pickUpChipContainer: {
      alignItems: 'center',
    },
    chipRoot: {
      borderRadius: '0.25rem',
      fontSize: '0.75rem',
      fontFamily: 'PP Object Sans',
      height: 'auto',
      width: 'min-content',
      fontWeight: 500,
      padding: '0.25rem 0.5rem',
      justifySelf: 'start',
      backgroundColor: neutral[10],
      color: neutral[80],
    },
    payInCashChip: {
      backgroundColor: Colors.DANGER_FONT_COLOR,
      color: Colors.WHITE,
      '&:hover': {
        backgroundColor: Colors.DANGER_FONT_COLOR,
      },
    },
  };
});
